interface Configuration {
  readonly keycloakUrl: string;
  readonly redirectUri: string;
  readonly baseUrl: string;
  readonly logoutUrl: string;
  readonly keycloakClientId: string;
  readonly keycloakRealm: string;
}

const { VITE_CALIZA_CUSTOMER_DASHBOARD_KEYCLOAK_URL, VITE_CALIZA_CUSTOMER_DASHBOARD_HOST } =
  import.meta.env;

export const configuration: Configuration = {
  keycloakUrl: VITE_CALIZA_CUSTOMER_DASHBOARD_KEYCLOAK_URL,
  redirectUri: `${VITE_CALIZA_CUSTOMER_DASHBOARD_HOST}/`,
  baseUrl: VITE_CALIZA_CUSTOMER_DASHBOARD_KEYCLOAK_URL,
  logoutUrl: `${VITE_CALIZA_CUSTOMER_DASHBOARD_HOST}/logout`,
  keycloakClientId: 'caliza-customer-dashboard',
  keycloakRealm: 'caliza',
};
